import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, ShieldCheck, Clock, DollarSign, FileCheck, BarChart3, Globe, BookOpen } from 'lucide-react';
const STATS = [{
  n: '+500',
  label: 'Profesionales que ya usan el sistema',
  Icon: TrendingUp,
  color: '#C8932A'
}, {
  n: '30',
  label: 'Días para tener el sistema funcionando',
  Icon: Clock,
  color: '#1E9B8A'
}, {
  n: '77%',
  label: 'De ahorro vs comprar cada producto por separado',
  Icon: DollarSign,
  color: '#C8932A'
}, {
  n: '8',
  label: 'Capítulos del sistema de blindaje profesional',
  Icon: BookOpen,
  color: '#1E9B8A'
}];
const OUTCOMES = [{
  Icon: ShieldCheck,
  color: '#C8932A',
  title: 'Respondé notificaciones ARCA sin consulta adicional',
  desc: 'Los 2 modelos de notas legales del Kit de Respuesta te permiten preparar tu propio descargo, validarlo con tu contador y presentarlo en término.'
}, {
  Icon: BarChart3,
  color: '#1E9B8A',
  title: 'Sabé exactamente cuánto ganás cada mes',
  desc: 'El Excel Maestro centraliza honorarios, gastos, Monotributo proyectado y fondo de inversión en un solo archivo. 20 minutos el primer día de cada mes.'
}, {
  Icon: DollarSign,
  color: '#C8932A',
  title: 'Dolarizá el 10% de tus ingresos mensualmente',
  desc: 'La Guía de Inversión Defensiva explica paso a paso cómo comprar Dólar MEP y armar una cartera de CEDEARs sin intermediarios ni asesores.'
}, {
  Icon: FileCheck,
  color: '#1E9B8A',
  title: 'Operá con tranquilidad ante los controles de ARCA',
  desc: 'El sistema de 7 pilares del Blindaje Profesional organiza tu situación fiscal para que, ante cualquier consulta, toda tu documentación esté en orden.'
}, {
  Icon: Globe,
  color: '#C8932A',
  title: 'Cobrá en dólares reales desde Argentina',
  desc: 'La Masterclass Freelancer Global te da el sistema completo: plataformas, cómo presentarte, cómo cobrar cumpliendo la normativa BCRA 2025 y plan de 90 días.'
}, {
  Icon: TrendingUp,
  color: '#1E9B8A',
  title: 'Reducí tus consultas al contador en un 80%',
  desc: 'Con el Excel Maestro, el Blindaje y el Kit ARCA, las preguntas frecuentes sobre categorías, deducibles y notificaciones las resolvés vos mismo.'
}];
const COVERAGE = ['Resolución de inconsistencias ARCA', 'Control financiero mensual automatizado', 'Dolarización legal de ahorros', 'Facturación en USD para el exterior', 'Gestión del Monotributo sin sorpresas', 'Inversión defensiva en CEDEARs'];
export function SocialProofSection() {
  return <section className="bg-navy-mid py-16 md:py-24 px-4" data-id="element-266">
      <div className="max-w-6xl mx-auto" data-id="element-267">

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-268">
          <p className="text-xs font-bold text-teal tracking-widest uppercase mb-4" data-id="element-269">
            Qué vas a lograr con el kit
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-white leading-[1.1] mb-4" data-id="element-270">
            Resultados concretos,{' '}
            <span className="gold-shine" data-id="element-271">no promesas vacías</span>
          </h2>
          <p className="text-white/45 text-base md:text-lg max-w-2xl mx-auto" data-id="element-272">
            Cada producto fue diseñado para resolver un problema específico y medible del profesional independiente argentino.
          </p>
        </motion.div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-14" data-id="element-273">
          {STATS.map(({
          n,
          label,
          Icon,
          color
        }, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="bg-white/[0.04] border border-white/[0.07] rounded-2xl p-5 text-center flex flex-col items-center gap-3" data-id="element-274">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
            background: color + '18',
            border: `1px solid ${color}35`
          }} data-id="element-275">
                <Icon className="w-5 h-5" style={{
              color
            }} data-id="element-276" />
              </div>
              <div className="font-display leading-none" style={{
            fontSize: 'clamp(28px, 5vw, 40px)',
            color
          }} data-id="element-277">
                {n}
              </div>
              <p className="text-white/45 text-xs leading-relaxed" data-id="element-278">{label}</p>
            </motion.div>)}
        </div>

        {/* Outcome cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14" data-id="element-279">
          {OUTCOMES.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.07
        }} className="bg-white/[0.03] hover:bg-white/[0.055] border border-white/[0.06] rounded-2xl p-6 transition-all duration-300 group" data-id="element-280">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" style={{
            background: item.color + '18',
            border: `1px solid ${item.color}30`
          }} data-id="element-281">
                <item.Icon className="w-5 h-5" style={{
              color: item.color
            }} data-id="element-282" />
              </div>
              <h3 className="font-display text-sm md:text-base text-white mb-2 leading-snug" data-id="element-283">
                {item.title}
              </h3>
              <p className="text-white/45 text-xs md:text-sm leading-relaxed" data-id="element-284">{item.desc}</p>
            </motion.div>)}
        </div>

        {/* Coverage card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.55
      }} className="rounded-3xl p-7 md:p-10" style={{
        background: 'linear-gradient(135deg, rgba(200,147,42,0.07) 0%, rgba(30,155,138,0.05) 100%)',
        border: '1px solid rgba(200,147,42,0.18)'
      }} data-id="element-285">
          <p className="text-xs font-bold text-teal tracking-widest uppercase mb-3" data-id="element-286">
            Todo lo que cubrís
          </p>
          <h3 className="font-display text-xl md:text-2xl text-white mb-7 leading-snug" data-id="element-287">
            Un sistema completo para el profesional argentino de 2026
          </h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3" data-id="element-288">
            {COVERAGE.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-289">
                <div className="w-5 h-5 rounded-full bg-teal/15 border border-teal/30 flex items-center justify-center flex-shrink-0" data-id="element-290">
                  <ShieldCheck className="w-3 h-3 text-teal" data-id="element-291" />
                </div>
                <span className="text-white/70 text-sm" data-id="element-292">{item}</span>
              </div>)}
          </div>
        </motion.div>

      </div>
    </section>;
}